import { Col, Form, Row } from "react-bootstrap";
import TextInput from "./TextInput";
import React from "react";

function TextComponent({
  labelText,
  onChangeSetFunction,
  onLockFunction,
  textData,
  textInputLabel,
  idName,
  errorProperty,
  teacherMode
}) {
  return /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    lg: 12
  }, /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Label, null, labelText), /*#__PURE__*/React.createElement(TextInput, {
    errorProperty: errorProperty,
    onChange: e => onChangeSetFunction(e.target.value),
    onLock: () => onLockFunction(),
    textData: textData,
    label: textInputLabel,
    teacherMode: teacherMode,
    id: idName
  }))));
}

export default TextComponent;